module.exports = __webpack_public_path__ + "img/yoga1.71c47a13.jpg";